import { useCallback, useRef } from 'react';

/**
 * Versteckter Zugang zum Elternbereich: langes Draufhalten.
 * Fuer Kinder nicht zufaellig ausloesbar, fuer Erwachsene sofort machbar.
 *
 * `pointercancel` wird bewusst NICHT behandelt: iOS bricht Zeigereignisse
 * beim langen Draufhalten gelegentlich ab (Kontextmenue, Scrollgeste). Wuerde
 * das den Timer stoppen, kaeme man auf dem iPad nicht mehr ins Elternmenue.
 * Das Loslassen (`pointerup`) beendet den Timer zuverlaessig.
 */
export function useLongPress(onLongPress: () => void, delayMs = 2500) {
  const timerRef = useRef<number | undefined>(undefined);

  const clear = useCallback(() => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
      timerRef.current = undefined;
    }
  }, []);

  const start = useCallback(() => {
    clear();
    timerRef.current = window.setTimeout(onLongPress, delayMs);
  }, [clear, delayMs, onLongPress]);

  return {
    onPointerDown: start,
    onPointerUp: clear,
    onPointerLeave: clear,
  };
}
